module.exports = __webpack_public_path__ + "media/images/about_us_shape-bcc94ecc9f1fb5798f4368073c51aca0.png";